import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaUserCog,
  FaBook,
  FaLayerGroup,
  FaList,
  FaMoneyBill,
  FaBell,
} from "react-icons/fa";

const Sidebar = () => {
  const [open, setOpen] = useState(true);

  return (
    <div
      className={`${
        open ? "w-64" : "w-16"
      } bg-green-700 text-white transition-all duration-300 h-screen`}
    >
      <button
        className="p-2 text-xl"
        onClick={() => setOpen(!open)}
      >
        ☰
      </button>

      <nav className="mt-4 space-y-2">
        <Link to="/manage-user" className="flex items-center gap-2 p-2 hover:bg-green-600">
          <FaUserCog /> {open && "Manage User"}
        </Link>
        <Link to="/manage-course" className="flex items-center gap-2 p-2 hover:bg-green-600">
          <FaBook /> {open && "Manage Course"}
        </Link>
        <Link to="/manage-sub-course" className="flex items-center gap-2 p-2 hover:bg-green-600">
          <FaLayerGroup /> {open && "Manage Sub Course"}
        </Link>
        <Link to="/manage-batch" className="flex items-center gap-2 p-2 hover:bg-green-600">
          <FaList /> {open && "Manage Batch"}
        </Link>
        <Link to="/manage-tax" className="flex items-center gap-2 p-2 hover:bg-green-600">
          <FaMoneyBill /> {open && "Manage Tax"}
        </Link>
        <Link to="/manage-notice" className="flex items-center gap-2 p-2 hover:bg-green-600">
          <FaBell /> {open && "Manage Notice"}
        </Link>
      </nav>
    </div>
  );
};

export default Sidebar;
